import { routes } from '@/constants';
import { FC, Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from '@/routes/ProtectedRoute';
import { Home } from '@/routes/home';
import { NotFound } from '@/routes/notFound';

const Creation = lazy(() => import('@/routes/creation').then(m => ({ default: m.Creation })));
const Cleaning = lazy(() => import('@/routes/cleaning').then(m => ({ default: m.Cleaning })));
const Capture = lazy(() => import('@/routes/capture').then(m => ({ default: m.Capture })));
const Credits = lazy(() => import('@/routes/credits').then(m => ({ default: m.Credits })));

const App: FC = () => {
  return (
    <Suspense fallback={<div className="p-4">Loading…</div>}>
      <Routes>
      <Route path={routes.home}>
        <Route index={true} element={<Home />} />
        <Route
          path={routes.capture}
          element={<ProtectedRoute element={<Creation />} allowedRoles={['kapnetix-admin', 'kapnetix-kapture']} />}
        />
        <Route
          path={routes.captureDetail}
          element={<ProtectedRoute element={<Capture />} allowedRoles={['kapnetix-admin', 'kapnetix-kapture']} />}
        />
        <Route
          path={routes.cleaning}
          element={<ProtectedRoute element={<Cleaning />} allowedRoles={['kapnetix-admin', 'kapnetix-cleaning']} />}
        />
        <Route
          path={routes.credits}
          element={<Credits />}
        />
        <Route path={routes.notFound} element={<NotFound />} />
      </Route>
      </Routes>
    </Suspense>
  );
};

export default App;
